import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CompleteGuide from "../pages/article/vigorbuy-spreadsheet-complete-guide/page";
import SafetyGuide from "../pages/article/vigorbuy-spreadsheet-safety-guide/page";
import BestSneakers from "../pages/article/best-sneakers-vigorbuy-spreadsheet/page";
import HoodieShopping from "../pages/article/hoodie-shopping-vigorbuy-spreadsheet/page";
import BestDeals from "../pages/article/find-best-deals-vigorbuy-spreadsheet/page";
import BeginnersGuide from "../pages/article/vigorbuy-spreadsheet-beginners-guide/page";
import ProductResearch from "../pages/article/vigorbuy-spreadsheet-product-research/page";
import CategoryComparison from "../pages/article/vigorbuy-spreadsheet-category-comparison/page";
import TopCategories from "../pages/article/top-vigorbuy-spreadsheet-categories/page";
import ShoppingStrategy from "../pages/article/vigorbuy-spreadsheet-shopping-strategy/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/article/vigorbuy-spreadsheet-complete-guide", element: <CompleteGuide /> },
  { path: "/article/vigorbuy-spreadsheet-safety-guide", element: <SafetyGuide /> },
  { path: "/article/best-sneakers-vigorbuy-spreadsheet", element: <BestSneakers /> },
  { path: "/article/hoodie-shopping-vigorbuy-spreadsheet", element: <HoodieShopping /> },
  { path: "/article/find-best-deals-vigorbuy-spreadsheet", element: <BestDeals /> },
  { path: "/article/vigorbuy-spreadsheet-beginners-guide", element: <BeginnersGuide /> },
  { path: "/article/vigorbuy-spreadsheet-product-research", element: <ProductResearch /> },
  { path: "/article/vigorbuy-spreadsheet-category-comparison", element: <CategoryComparison /> },
  { path: "/article/top-vigorbuy-spreadsheet-categories", element: <TopCategories /> },
  { path: "/article/vigorbuy-spreadsheet-shopping-strategy", element: <ShoppingStrategy /> },
  { path: "*", element: <NotFound /> },
];

export default routes;